const BooleanTest = (valueToTest) => {
	if(valueToTest == 'true'){
		return true
	}
	else {
		return false
	}
}

module.exports = BooleanTest;


// WEBPACK FOOTER //
// ./lib/booleanTest.js